import { all, AllEffect, ForkEffect, put, takeLatest } from 'redux-saga/effects';
import { ANALYZE_FLYOUT, AnalyzeFlyoutAction } from 'b2b-apps/shop/analytics/redux';
import { analyzeEvent } from 'b2b-apps/shop/analytics/redux/tealium/actionCreators';
import { TEALIUM_INTERACTION_ID } from 'b2b-apps/shop/analytics/types/types';

function* analyzeFlyoutUsageSaga(
  action: AnalyzeFlyoutAction,
): Generator<any, any, any> {
  const { path, url, position } = action.payload;
  const sanitizedPath = path.filter((v) => !!v);

  yield put(analyzeEvent({
    interaction: TEALIUM_INTERACTION_ID.flyoutClick,
    component_category: ['nav'],
    component_subcategory: ['main_navigation'],
    component_attribute1: [url],
    component_attribute2: [sanitizedPath.join('/')],
    component_attribute3: ['click'],
    component_attribute4: [sanitizedPath[0]],
    component_attribute5: [sanitizedPath[1]],
    component_attribute6: [sanitizedPath[2]],
    component_location: [`Level ${sanitizedPath.length}`],
    component_innerlocation: [`${position}`],
  }));
}

function* menuAnalyticsSaga(): Generator<AllEffect<ForkEffect>, void> {
  yield all([
    takeLatest(ANALYZE_FLYOUT, analyzeFlyoutUsageSaga),
  ]);
}

export {
  menuAnalyticsSaga,
};
